import React from 'react';
import styled from 'styled-components/macro';

export const Wrapper = styled.svg`
  aspect-ratio: 1/1;
  height: 100%;
  width: 100%;

  path { 
    transform-box: fill-box;
    transition: 0.25s;
  }
`;

const Top = styled.path(({ $active }: { $active: boolean }) => `
  transform: 
    translate(${$active ? "18%, 0%" : "0%, 0%"}) 
    rotateZ(${$active ? "45deg" : "0"});
`);

const Middle = styled.path(({ $active }: { $active: boolean }) => `
  opacity: ${$active ? "0" : "1"};
`);

const Bottom = styled.path(({ $active }: { $active: boolean }) => `
  transform-origin: right center;

  transform: 
    translate(${$active ? "-5rem, -21rem" : "0, 0"})
    rotateZ(${$active ? "-45deg" : "0 "});
`);

const Menu = React.forwardRef(({ active = false }: {
  active?: boolean
}, ref: React.ForwardedRef<SVGSVGElement>
) => (
  <Wrapper
    ref={ref}
    enableBackground="new 0 0 32 32"
    height={512} viewBox="0 0 32 32" width={512}
  >
    <g id="Layer_1" fill="rgb(0,0,0)">
      <Top $active={active} d="m29 8h-26c-1.1045 0-2-.8955-2-2s.8955-2 2-2h26c1.1045 0 2 .8955 2 2s-.8955 2-2 2z" />
      <Bottom $active={active} d="m29 28h-26c-1.1045 0-2-.8955-2-2s.8955-2 2-2h26c1.1045 0 2 .8955 2 2s-.8955 2-2 2z" />
      <Middle $active={active} d="m29 18h-26c-1.1045 0-2-.8955-2-2s.8955-2 2-2h26c1.1045 0 2 .8955 2 2s-.8955 2-2 2z" />
    </g>
  </Wrapper>
));

export default Menu;